// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Mp-z","slideIn":"Np-z"};